<template>
  <ECharts :options="optoin" style="width: 100%; height: 100%;" />
</template>

<script>
import ECharts from 'vue-echarts/components/ECharts'
import 'echarts-gl'

import baseTexture from '@/assets/earthImgs/world.topo.bathy.200401.jpg'
import heightTexture from '@/assets/earthImgs/bathymetry_bw_composite_4k.jpg'
// import environment from '@/assets/earthImgs/starfield.jpg'

export default {
  components: {
    ECharts
  },
  props: {
    lines: Array
  },
  computed: {
    optoin () {
      return {
        backgroundColor: '#000',
        globe: {
          baseTexture,
          heightTexture,
          shading: 'lambert',
          environment: '#1c2d87',
          globeRadius: 100,
          // eslint-disable-next-line
          shading: 'color',
          // light: {
          //   ambient: {
          //     intensity: 0.6
          //   },
          //   main: {
          //     intensity: 0.6
          //   }
          // },
          viewControl: {
            autoRotate: false,
            // 定位到北京 alpha beta 将无效
            targetCoord: [116.46, 39.92]
            // alpha: 30, // x轴旋转
            // beta: 200 // y轴旋转
          }
        },
        series: {
          type: 'lines3D',
          coordinateSystem: 'globe',
          blendMode: 'lighter',
          lineStyle: {
            width: 2,
            color: 'rgb(50, 50, 150)',
            opacity: 1
          },
          data: this.lines
        }
      }
    }
  }
}
</script>
